export default __webpack_public_path__ + "static/media/not-valid-icon.4738aa9c.svg";